import useCurrentTeam from './useCurrentTeam';

const useCurrency = () => {
	const currentTeam = useCurrentTeam();

	return currentTeam?.currencyMapping || { gbp: 2, eur: 1.769, usd: 1.656 };
};

export default useCurrency;
